module.exports = __webpack_public_path__ + "static/media/1f4a9.8359db31.svg";